// import { useState } from "react";
// import { Button, ConfigProvider, Layout } from "antd";
// import { Link, Outlet } from "react-router-dom";
// const { Header, Content } = Layout;
// import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
// import ExamSidebar from "../components/shared/ExamSidebar";
// const ExamLayout = () => {
//   const [collapsed, setCollapsed] = useState(false);
//   return (
//     <ConfigProvider theme={{}}>
//       <Layout>
//         <Header className="pl-0 pr-10 bg-background text-text_clr flex items-center justify-between border-b">
//           <div className="flex items-center">
//             <div className="w-[80px] flex justify-center">
//               <Button
//                 type="text"
//                 icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
//                 onClick={() => setCollapsed(!collapsed)}
//               />
//             </div>
//             <div className="grid items-center h-16 font-semibold">
//               <Link to="/" className="text-5xl text-center text-slate-400">
//                 G
//               </Link>
//             </div>
//           </div>
//           <Button variant="solid" color="danger">
//             Logout
//           </Button>
//         </Header>
//         <Layout className="h-[calc(100vh-64px)]">
//           <ExamSidebar collapsed={collapsed} />
//           <Layout>
//             <Content className="px-8 py-5 bg-background text-text_clr">
//               <Outlet />
//             </Content>
//           </Layout>
//         </Layout>
//       </Layout>
//     </ConfigProvider>
//   );
// };

// export default ExamLayout;

import { useState, useEffect } from "react";
import { Button, ConfigProvider, Layout, Drawer } from "antd";
import { Link, Outlet, useNavigate, useLocation } from "react-router-dom";
const { Header, Content } = Layout;
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import ExamSidebar from "../components/shared/ExamSidebar";

const ExamLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false); // State for Drawer visibility

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const tokenData = JSON.parse(localStorage.getItem("faceAuthTokenData"));
    const access_token = tokenData?.token?.access;

    if (!access_token && location.pathname !== "/login") {
      navigate("/login");
    }
  }, [navigate, location.pathname]);

  // Handle window resize to automatically collapse the sidebar on mobile
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setCollapsed(true); // Collapse sidebar on mobile
        setDrawerOpen(false); // Close the drawer on mobile by default
      } else {
        setCollapsed(false); // Expand sidebar on larger screens
      }
    };

    // Initial check for screen size
    handleResize();

    // Add resize event listener
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <ConfigProvider theme={{}}>
      <Layout>
        <Header className="pl-0 pr-10 bg-background text-text_clr flex items-center justify-between border-b">
          <div className="flex items-center">
            <div className="w-[80px] flex justify-center">
              {/* Button to toggle the drawer on mobile */}
              <Button
                type="text"
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={() => {
                  if (window.innerWidth < 768) {
                    setDrawerOpen(!drawerOpen); // Toggle drawer on mobile
                  } else {
                    setCollapsed(!collapsed); // Toggle sidebar on larger screens
                  }
                }}
              />
            </div>
            <div className="grid items-center h-16 font-semibold">
              <Link to="/" className="text-5xl text-center text-slate-400">
                G
              </Link>
            </div>
          </div>
          <Button variant="solid" color="danger">
            Logout
          </Button>
        </Header>
        <Layout className="h-[calc(100vh-64px)]">
          {/* Sidebar for larger screens */}
          <div className="hidden md:block">
            <ExamSidebar collapsed={collapsed} />
          </div>

          {/* Drawer for mobile */}
          <Drawer
            title="Menu"
            placement="left"
            closable
            onClose={() => setDrawerOpen(false)}
            open={drawerOpen}
            width={250}
          >
            <ExamSidebar collapsed={false} />{" "}
            {/* Mobile version of the sidebar */}
          </Drawer>

          <Layout>
            <Content className="px-8 py-5 bg-background text-text_clr">
              <Outlet />
            </Content>
          </Layout>
        </Layout>
      </Layout>
    </ConfigProvider>
  );
};

export default ExamLayout;
